function FeePlanSetup() {
  return <div>FeePlanSetup</div>;
}

export default FeePlanSetup;
